export default "__VITE_ASSET__DW2VCp9$__"